import { FC, useState } from 'react';

import { Image, ImageProps, Text } from '@mantine/core';

export interface FlagProps extends ImageProps {
  country: { name: string; value: string };
  size?:
    | 'w20'
    | 'w40'
    | 'w80'
    | 'w160'
    | 'w320'
    | 'w640'
    | 'w1280'
    | 'w2560'
    | 'h20'
    | 'h40'
    | 'h60'
    | 'h80'
    | 'h120'
    | 'h240';
}

export const Flag: FC<FlagProps> = ({
  country: { name, value },
  size = 'w20',
  ...rest
}) => {
  const [err, setErr] = useState(false);
  /**
   * libphonenumber-js supports country code AN (Netherlands Antilles)
   * where as flagcdn doesn't have such a code changing that to NL (Netherlands) to get the flag
   */
  const valueFinal = value === 'AN' ? 'NL' : value;
  return !err ? (
    <Image
      {...rest}
      fit="contain"
      src={`https://flagcdn.com/${size}/${valueFinal?.toLowerCase()}.webp`}
      alt={name}
      onError={() => setErr(true)}
    />
  ) : (
    <Text fz={10}>{value}</Text>
  );
};
